import { render, staticRenderFns } from "./ReviewCommDiscFactors.vue?vue&type=template&id=f311d81a&"
import script from "./ReviewCommDiscFactors.vue?vue&type=script&lang=js&"
export * from "./ReviewCommDiscFactors.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCommDiscFactors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewCommDiscFactors.vue"
export default component.exports